import React, { useState } from 'react';
import moment from 'moment';
const CustomDatePicker = ({ id, onChange, value, isRequired, ...props }) => {
	let [selectedDate, setSelectedDate] = useState(value);
	return (
		<label className='form-control position-relative' for={id}>
			<span className='font-weight-normal'>
				{selectedDate
					? moment(selectedDate).format('DD/MM/YYYY')
					: 'dd/mm/yyyy'}
			</span>
			<input
				type='date'
				id={id}
				name={id}
				style={{ opacity: 0, top: 0, left: 0 }}
				className='position-absolute w-100 h-100'
				onChange={e => {
					setSelectedDate(e.target.valueAsDate);
					onChange(e);
				}}
				required={isRequired}
				{...props}
			/>
		</label>
	);
};

export default CustomDatePicker;
